module.exports = __webpack_public_path__ + "img/icon-play.c3002d5a.png";